import type { ProcessOfferItemDto } from '@/api/generated';

export type ProcessOfferItemWithChain = ProcessOfferItemDto & { __chainIndex: number };

export const sortAndAugmentByChain = (
  items: ProcessOfferItemDto[],
): ProcessOfferItemWithChain[] => {
  const sorted = [...items].sort((a, b) => {
    if (a.versionCorrelationId === b.versionCorrelationId) {
      return a.versionNumber - b.versionNumber;
    }
    return a.versionCorrelationId.localeCompare(b.versionCorrelationId);
  });

  let chainIndex = 0;
  let lastCorrelationId: string | null = null;
  return sorted.map(item => {
    if (lastCorrelationId !== null && item.versionCorrelationId !== lastCorrelationId) {
      chainIndex = (chainIndex + 1) % 2;
    }
    lastCorrelationId = item.versionCorrelationId;
    return { ...item, __chainIndex: chainIndex };
  });
};
